import { TEditCategoryAction, EditCategoryActionTypes } from './editCategoryActions';
import { IEditCategoryState } from './editCategoryContext';

export const editCategoryReducer = (state: IEditCategoryState, action: TEditCategoryAction): IEditCategoryState => {
	switch (action.type) {
		case EditCategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditCategoryActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditCategoryActionTypes.SET_ALL_DATA:
			return {
				...state,
				categoryID: action.payload.categoryID,
				filePath: action.payload.filePath,
				preSignedUrl: action.payload.preSignedUrl,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				nameOfCategory: action.payload.nameOfCategory,
				categoryType: action.payload.categoryType,
				subcategoriesOfCategory: action.payload.subcategoriesOfCategory,
				isRestricted: action.payload.isRestricted,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				translations: action.payload.translations,
			};
		case EditCategoryActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditCategoryActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditCategoryActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditCategoryActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case EditCategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				defaultCustomerLanguage: null,
			};
		case EditCategoryActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case EditCategoryActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case EditCategoryActionTypes.CHANGE_NAME_OF_CATEGORY:
			return {
				...state,
				nameOfCategory: action.payload.nameOfCategory,
			};
		case EditCategoryActionTypes.SET_CATEGORY_TYPE:
			return {
				...state,
				categoryType: action.payload.categoryType,
			};
		case EditCategoryActionTypes.TOGGLE_IS_RESTRICTED:
			return {
				...state,
				isRestricted: !state.isRestricted,
			};
		case EditCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditCategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
